/*jshint esversion: 6 */
/*jshint strict: false */

import $ from 'jquery';

import * as homepage from "./homepage";
import * as social from "./social";

let dataDir = '/film-scores/data/';

homepage.init(dataDir);
social.init();

$('.scrolltop').on('click', function(e) {
    $('html, body').animate({scrollTop:0}, 500);
});
$('.sources').on('click', function(e) {
    $('.modal-container').fadeIn();
});
$('.modal-container').on('click', function(e) {
    $('.modal-container').fadeOut();
});


// WEBPACK FOOTER //
// ./app.js